import { useTranslation } from 'react-i18next';

interface Props {
  role: Nullable<number>;
}

export default function MessageDecoratorRole({ role }: Props) {
  const { t } = useTranslation();

  if (role === 0) return null;

  return (
    <span className='rounded whitespace-nowrap p-1 bg-primary text-primary-content leading-none text-[8px]'>
      {role === 9 ? t('conversation.setting.group.admin.admin') : t('conversation.setting.group.owner')}
    </span>
  );
}
